<template>
	<div class="">
		<b-button variant="link" class="p-0 mb-4 d-none d-lg-block" @click="backHandler">
			Вернуться назад
		</b-button>

		<template v-if="isShowPoints && !isFreePromocode">
			<div class="row">
				<points-window
					class="col-12 mb-3"
					show-default-block
					:card-background="cardBackground"
					:final-price="+initialPrice"
					:original-price="+initialPrice"
					:loyalty-data="loyaltyData"
					:fetched-data="fetchedData"
					:block="block"
					:loyalty-profile="loyaltyProfile"
					:products="order.data.products"
					:is-promo-code-used="isActivatePromocode"
					:charged-points="order.chargedPoints"
					:charged-premium-points="order.chargedPremiumPoints"
					hide-final-price
					@setLoyaltyData="setLoyaltyData"
					@updatePoints="updatePoints"
					@hidePoints="hidePoints"
				/>
			</div>
		</template>

		<div v-if="isPhysicalPayer" class="provider-row border-0">
			<div v-if="!isFreeOrder" class="title mb-2">
				Выбор способа оплаты
			</div>
			<div v-if="!isFreeOrder" class="row mb-4">
				<div v-if="isLoading" class="col-12 my-4 d-flex justify-content-center">
					<b-spinner variant="primary" />
				</div>
				<template v-else>
					<div
						v-for="provider in providers"
						:key="provider.id"
						class="col-12 col-sm-3 provider border-bottom-0"
						@click="setProvider(provider)"
					>
						<div class="btn-provider" :class="{ active: activeProviderName === provider.entity }">
							<b-img
								v-if="provider.css_classes === 'icon-sberbank'"
								width="32"
								src="/svg/qr-code.svg"
								class="mb-2 btn_provider-svg qr"
							/>
							<div v-else :class="`mb-2 btn_provider-svg ${provider.css_classes}`" />
							<div class="d-flex flex-column align-items-center">
								<span class="provider-title">{{ provider.name }}</span>
								<span class="provider-description">{{ provider.description }}</span>
							</div>
						</div>
					</div>
				</template>
			</div>
			<div v-if="isTinkoffProvider">
				<div>
					<b-form-select
						v-model="loanPromoCode"
						:options="loanPromoCodes"
						name="loan_promo_code"
						class="my-3 px-3 col-4 loanPromoCode"
					>
						<template #first>
							<b-form-select-option
								:value="null"
								disabled
							>
								Период и ставка рассрочки
							</b-form-select-option>
						</template>
					</b-form-select>
				</div>
				<div>
					<span v-if="message" class="ml-2 text-danger"> {{ message }}</span>
				</div>
			</div>
		</div>
		<div v-else class="row mb-4">
			<div
				v-if="!isFreeOrder"
				class="col-12 mb-4"
			>
				<div class="title mb-4">
					Оплатить по счету
				</div>
				<FormulateForm
					v-model="values"
					name="checkoutInfo"
					remove-label
					@submit="checkoutSubmit"
				>
					<div class="row mb-4">
						<div class="col-12">
							<div class="description strong mb-5">
								Реквизиты
							</div>
							<FormulateInput
								type="CustomDadataBank"
								label="Название банка*"
								name="bank"
								:input_options="{placeholder: 'Введите значение'}"
								:style-classes="'user-profile-dadata-input position-relative'"
								validation="required"
								validation-name="bank"
								:validation-messages="{
									'required': 'необходимо выбрать банк из справочника',
								}"
								class="user-profile-field"
								@setBankInfo="(value) => fullBank = value"
							/>
							<FormulateInput
								type="text"
								label="БИК*"
								name="bik"
								placeholder="Введите значение"
								validation-name="БИК"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								type="text"
								label="Корреспондентский счет в ЦБ РФ*"
								name="correspondent_account"
								placeholder="Введите значение"
								validation-name="Корреспондентский счет в ЦБ РФ"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								type="text"
								label="Расчетный счет*"
								name="checking_account"
								placeholder="Введите значение"
								validation-name="Расчетный счет"
								validation="bail|required|number|between:19,21,length"
								:validation-messages="{
									'required': 'обязательно к заполнению',
									'between': 'счет должен состоять из 20 цифр',
									'number': 'можно использовать только цифры',
								}"
							/>
						</div>
					</div>
				</FormulateForm>
			</div>
		</div>

		<div class="row">
			<!--	Promocode	-->
			<div v-if="!order.chargedPoints && !isFreeLoyalty" class="col-12 mb-4 mb-lg-0">
				<div class="mb-4">
					<label class="mb-2" for="promocode">Промокод</label>
					<div
						class="formulate-promocode"
						:class="isActivatePromocode ? 'formulate-promocode--active' : ''"
					>
						<FormulateInput
							v-if="!isActivatePromocode"
							id="promocode"
							v-model.trim="promocode"
							type="text"
							name="promo"
							placeholder="Промокод"
							class="px-0 mb-0 mr-2 promocode-input col"
						/>
						<div v-else class="formulate-promocode--active__text px-0 col text-success">
							Промокод применен
						</div>
						<div
							v-if="isActivatePromocode"
							class="close"
							@click="removePromocode"
						/>
						<b-button
							v-else-if="promocode"
							variant="link"
							@click="sendPromocode"
						>
							Применить
						</b-button>
					</div>
					<div
						class="formulate-promocode__error"
					>
						{{ promocodeMessage }}
					</div>
				</div>
			</div>

			<div class="col-12 my-2">
				<FormulateInput
					v-for="(item, index) in agreements"
					ref="agreementInput"
					:key="`agreement-${index}`"
					class="mb-3 small"
					name="publicOfferAgreement"
					type="checkbox"
					validation="required"
					:validation-messages="{
						required: $t('agreementRequired')
					}"
					data-action="publicOfferAgreement"
				>
					<template #label="{ id }">
						<label :for="id" class="ml-2">
							Согласен с <a :href="item" target="_blank"> договором оферты </a>
						</label>
					</template>
				</FormulateInput>
			</div>

			<div
				class="col-12 order-7 d-flex flex-column justify-content-start mb-4"
				@click="submitHandler"
			>
				<div class="w-100 d-flex">
					<b-button
						variant="outline-primary"
						class="w-25 d-lg-none mr-2"
						@click="backHandler"
					>
						Назад
					</b-button>
					<button class="submit btn btn-primary w-100" :disabled="isSubmitDisabled">
						<span v-if="isLoading">
							<b-spinner small />
						</span>
						<span v-else>{{ submitText }}</span>
					</button>
				</div>

				<div v-if="providerError" class="text-danger mt-2">
					Выберите способ оплаты
				</div>
				<div v-if="payError" class="text-danger mt-2">
					{{ payError }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PointsWindow from '~/components/formulate/loyalty/PointsWindow.vue';

import loyaltyPoints from '~/mixins/loyaltyPoints';
import paymentFormMixin from '~/mixins/paymentFormMixin';

import { FORM_PAYER_TYPE, ORDER_TYPES, PROMOCODE_ENTITIES } from '~/utils/dictionaries';
import {
	mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';

const PERSON_SCHEDULE_TYPE = 2;
const IP_SCHEDULE_TYPE = 3;

const ADDITIONAL_CHECKOUT_DATA = {
	bank: 'bank',
	bik: 'bik',
	correspondent_account: 'correspondent_account',
	bank_city: 'bank_city',
};

const FORM_FIELDS = [
	'bank',
	'bik',
	'correspondent_account',
	'checking_account',
	'bank_city',
];

const PROFILE_BANK_FIELDS = {
	bank_name_payment: 'bank',
	bank_bic: 'bik',
	bank_correspondent_account: 'correspondent_account',
	bank_legal_account: 'checking_account',
};

const CHECKOUT_PROVIDER = [86, 16];

export default {
	name: 'ThirdStep',
	components: { PointsWindow },
	mixins: [paymentFormMixin, loyaltyPoints],
	inject: ['order'],
	props: {
		block: {
			type: Object,
			default: () => {},
		},
		fetchedData: {
			type: Object,
			default: () => {},
		},
		payerType: {
			type: Number,
			default: FORM_PAYER_TYPE.PHYSICAL,
		},
	},
	data() {
		return {
			providerError: false,
			payError: false,
			latestPaymentProvider: null,
			checkoutExists: false,
			activeProvider: null,
			activeProviderName: '',
			providers: [],
			individualScheduleType: [PERSON_SCHEDULE_TYPE, IP_SCHEDULE_TYPE],
			cardBackground: null,
			loyaltyData: null,
			loyaltyProfile: {},
			loanPromoCode: null,
			loanPromoCodes: [
				{ value: 'installment_0_0_3_5,5_3,8', text: '3 месяца 6%' },
				{ value: 'installment_0_0_3_6,0', text: '4 месяца 7,5%' },
				{ value: 'installment_0_0_4_6,9', text: '6 месяцев 10,2%' },
				{ value: 'installment_0_0_4_7,5', text: '10 месяцев 15,5' },
				{ value: 'installment_0_0_6_9,5', text: '12 месяцев 18%' },
				{ value: 'installment_0_0_6_10,2', text: '3 месяца 5,5%' },
				{ value: 'installment_0_0_10_14,4_6,4', text: '4 месяца 6,9%' },
				{ value: 'installment_0_0_10_15,5', text: '6 месяцев 9,5%' },
				{ value: 'installment_0_0_12_16,6_5,8', text: '10 месяцев 14,4%' },
				{ value: 'installment_0_0_12_18', text: '12 месяцев 16,6%' },
			],
			message: null,
			billingOrderReference: null,
			values: {
				bank: null,
				bik: null,
				correspondent_account: null,
				checking_account: null,
				bank_city: null,
			},
			fullBank: null,
			isVisibleResetModal: false,
		};
	},
	computed: {
		...mapState('profile', ['formulateUserProfile']),
		...mapState('scenarios/paymentForm', ['form', 'isLoading', 'orderHash', 'personData']),
		...mapGetters('scenarios/paymentForm', [
			'payerType',
			'isIpPayer',
			'isPhysicalPayer',
			'totalPrice',
			'isRepresentative',
			'initialPrice',
			'isFreePromocode',
			'isFreeLoyalty',
			'isFreeOrder',
		]),
		isTinkoffProvider() {
			return this.activeProviderName === 'TinkoffProvider';
		},
		isSubmitDisabled() {
			return this.isLoading || (this.isTinkoffProvider && !this.loanPromoCode);
		},
		isShowPoints() {
			return this.loyaltyProfile?.id
				&& !this.isRepresentative
				&& (this.isBlockContainsLoyaltyEarnProduct
					|| this.isBlockContainsLoyaltyChargeProduct);
		},
		invoice() {
			return this.order.data?.invoices[0];
		},
		submitText() {
			if (this.isFreeOrder) {
				return 'Зарегистрироваться';
			}
			if (this.isPhysicalPayer) {
				return 'Оплатить';
			}
			if (this.isLoading) {
				return 'Скачивается...';
			}
			return 'Сформировать счет';
		},
		agreements() {
			return this.order.unauthAgreements ?? [];
		},
		promocodeEntityType() {
			return this.isPhysicalPayer ? PROMOCODE_ENTITIES.PHYSICAL : PROMOCODE_ENTITIES.LEGAL;
		},

		totalPointsToCharge() {
			const {
				pointsToCharge,
				premiumPointsToCharge,
			} = this.loyaltyData;
			return +pointsToCharge + +premiumPointsToCharge;
		},
		priceWithLoyaltyPoints() {
			return this.totalPrice - this.totalPointsToCharge;
		},
		payloadForPay() {
			const isTinkoff = this.activeProvider?.entity === 'TinkoffProvider';
			const promoCode = isTinkoff ? { promoCode: this.loanPromoCode } : {};
			const paymentProvider = this.isFreeOrder ? 'PromocodeProvider' : this.activeProvider?.entity;

			return {
				is_agree_offer: true,
				loyaltyData: this.loyaltyData,
				paymentProvider,
				...promoCode,
			};
		},
	},
	watch: {
		fullBank(val) {
			this.values.bik = null;
			this.values.correspondent_account = null;
			this.values.bank_city = null;
			if (val && val.value) {
				this.values.bank = val.value;
				if (val.data) {
					if (val.data.address) {
						this.values.bank_city = val.data.address.value;
					}
					this.values.bik = val.data.bic;
					this.values.correspondent_account = val.data.correspondent_account;
				}
			} else {
				this.values.bank = null;
			}
		},
	},
	async created() {
		await this.getProviders();
		await this.getLoyaltyProfile();
	},
	async mounted() {
		await this.getLatestPaymentProvider();
		await this.getCheckoutExists();
		this.autocompleteValues();
		if (this.personData.step !== 3) await this.updateBaseFormData();
	},
	methods: {
		...mapActions('scenarios/paymentForm', ['setCurrentStep']),
		...mapMutations('scenarios/paymentForm', [
			'setLoading',
			'setStep',
			'setPrice',
			'setVisibilityPromocodeModal',
			'setRedirectStep',
		]),
		async getLoyaltyProfile() {
			const { data } = await this.$api.getLoyaltyProfile();

			if (data) this.loyaltyProfile = data;
		},
		async getProviders() {
			this.providerError = false;
			this.setLoading(true);

			await this.$api.getProviders(this.orderHash).then((res) => {
				const condition = this.isPhysicalPayer
					? (item) => !item.legal_type || item.legal_type == FORM_PAYER_TYPE.PHYSICAL
					: (item) => !item.legal_type || item.legal_type == FORM_PAYER_TYPE.URIDIC;
				this.providers = res.data.filter(condition);
			}).finally(() => { this.setLoading(false); });
		},
		async getLatestPaymentProvider() {
			if (this.order.data.type !== ORDER_TYPES.FREE) {
				const {
					latest_payment_provider: latestPaymentProvider,
				} = await this.$api.getLatestPaymentProvider(this.orderHash);

				this.latestPaymentProvider = latestPaymentProvider;
			}
		},
		async getCheckoutExists() {
			if (this.order.data.type !== ORDER_TYPES.FREE) {
				const {
					data: checkoutExists,
				} = await this.$api.getCheckoutExists(this.orderHash);

				this.checkoutExists = checkoutExists;
			}
		},
		async setProvider(provider) {
			this.providerError = false;
			this.activeProvider = provider;
			this.activeProviderName = provider.entity;
		},
		isIndividualScheduleType(scheduleType) {
			return this.individualScheduleType.includes(scheduleType);
		},
		async validateAgreement() {
			// Валидация оферты
			const agreement = this.$refs.agreementInput[0];

			await agreement?.performValidation();
			if (!agreement?.isValid) {
				agreement.formShouldShowErrors = true;
			}

			return agreement?.isValid;
		},
		async submitHandler() {
			const isValid = await this.validateAgreement();
			if (!isValid) return;

			if (this.isFreeOrder) {
				await this.pay();
				await this.setCurrentStep('finish');
				return;
			}

			this.providerError = false;
			if (!this.isPhysicalPayer) {
				this.syncForm(FORM_FIELDS, this.values);
				this.$formulate.submit('checkoutInfo');
			} else if (this.activeProvider) {
				this.pay();
			} else {
				this.providerError = true;
			}
		},
		async pay(isCheckout = false) {
			this.setLoading(true);
			this.message = null;
			this.payError = null;

			if (this.invoice) {
				try {
					const { data } = await this.$api.payByInvoice(this.invoice, this.payloadForPay);
					// let data = null;
					// if (this.order?.data?.is_tranche == 1) {
					// 	data = await this.$api.checkoutPayByTranche(this.invoice, payload);
					// } else {
					// 	data = await this.$api.payByInvoice(this.invoice, payload);
					// }

					if (this.isFreeOrder) {
						this.setLoading(false);
						return;
					}

					if (this.activeProvider?.entity !== 'CheckoutProvider' && data.success) {
						await this.updateBaseFormData();
						window.location = data.payment_url;
						// window.location = data.payment_url ?? data.url;
					} else if (!data.success) {
						this.message = data.message;
					}

					this.billingOrderReference = data.order?.reference;

					if (!isCheckout) {
						this.setLoading(false);
					}
				} catch (e) {
					console.error(e);
					const { message } = e.response?.data;
					this.payError = message || 'Произошла ошибка при отправке формы';
					this.setLoading(false);
				}
			}
		},
		async checkoutSubmit() {
			const { payer: { inn } } = this.form;
			const { user_data: { payer } } = this.personData;
			// Выбор локальных или сохраненных данных компании плательщика
			const payerData = inn ? this.form.payer : payer;

			try {
				this.setLoading(true);
				this.activeProvider = this.providers.find((item) => item.entity === 'CheckoutProvider');
				await this.pay(true);

				await this.saveBankInProfile();
				const response = await this.$api.createCheckoutForUridic({
					is_agree_offer: true,
					values: {
						...payerData,
						...this.form,
						inn: payerData?.inn,
						type_people: 'uridic',
						timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
					},
					reference: this.billingOrderReference,
					loyaltyData: this.loyaltyData,
				});

				this.checkoutPdf = response.url;
				window.location = this.checkoutPdf;

				if (!this.isPhysicalPayer) {
					await this.setCurrentStep('finish');
				}
			} catch (error) {
				console.error('Ошибка при выполнении checkoutSubmit:', error);
			} finally {
				this.setLoading(false);
			}
		},
		extractIndex(data) {
			const regex = /^(\d{6}),/;
			const match = data?.match(regex);

			return match ? match[1] : data;
		},
		autocompleteCheckoutForm() {
			const { company, payer } = this.values;

			Object.entries(ADDITIONAL_CHECKOUT_DATA).forEach(([key, value]) => {
				if (company in value) {
					let data = company[value];

					if (key === 'index') {
						data = this.extractIndex(data);
					}

					this.values[key] = data;
				}
			});

			this.values.name = payer?.name;
			this.values.inn = payer?.inn;
			this.values.kpp = payer?.kpp;
			this.values.index = payer?.index;
			this.values.ur_address = payer?.address;
			this.values.address = payer?.address;
		},
		setLoyaltyData(val) {
			this.loyaltyData = val;
			const {
				showActivePointsCharging,
				showPremiumPointsCharging,
			} = this.loyaltyData;
			const isLoyaltyActive = showActivePointsCharging || showPremiumPointsCharging;

			if (isLoyaltyActive && !this.order.chargedPoints) {
				this.setPrice({ value: this.priceWithLoyaltyPoints.toString(), key: 'withLoyalty' });
			}
			if (!this.totalPointsToCharge) {
				this.setPrice({ value: null, key: 'withLoyalty' });
			}
		},
		updatePoints() {
			if (this.promocode) this.removePromocode();
			this.$nextTick(() => {
				this.loyaltyData.actualAmount = this.priceWithLoyaltyPoints;
				if (!this.totalPointsToCharge) this.setPrice({ value: null, key: 'withLoyalty' });
			});
			if (this.order.chargedPoints) {
				const price = this.order.data.amount;
				this.setPrice({ value: price, key: 'initial' });
			}
		},
		hidePoints() {
			if (this.order.chargedPoints) {
				const price = (+this.loyaltyData.actualAmount + +this.order.chargedPoints).toFixed(2);
				this.setPrice({ value: price, key: 'initial' });
			}
		},
		backHandler() {
			const physicalPayerStep = this.isRepresentative ? this.STEPS.INFO : this.STEPS.DOCUMENTS;
			const step = this.isPhysicalPayer ? physicalPayerStep : this.STEPS.COMPANY;

			if (this.isActivatePromocode) {
				this.setVisibilityPromocodeModal(true);
				this.setRedirectStep(step);
				return;
			}
			this.setStep(step);
		},
		async sendPromocode() {
			await this.applyPromocode(this.promocode, this.invoice.reference, this.promocodeEntityType);
			this.setPrice({ value: null, key: 'withLoyalty' });
		},
		removePromocode() {
			this.resetPromocodeForm(this.promocode, this.invoice.reference);
		},
		async saveBankInProfile() {
			try {
				const formData = new FormData();
				Object.keys(PROFILE_BANK_FIELDS)?.forEach((key) => {
					formData.append(`values[${key}]`, this.values[PROFILE_BANK_FIELDS[key]]);
				});
				await this.$api.setUserProfileFields(formData);
			} catch (e) {
				console.error(e);
			}
		},
		autocompleteValues() {
			Object.keys(PROFILE_BANK_FIELDS)?.forEach((key) => {
				this.values[PROFILE_BANK_FIELDS[key]] = this.formulateUserProfile[key];
			});
		},
	},
};

</script>

<style lang="scss">
@import '~/assets/styles/sk_variables';
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";

@import "~/assets/styles/components/dev/order.scss";

.loyalty-card {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 1rem 2rem;
	border-radius: 0.5rem;
	font-size: 1.2rem;
	width: fit-content;
	line-height: normal;

	&-title {
		text-transform: uppercase;
		font-weight: bold;
	}
}

.custom-switch {
	padding-left: 2.2rem !important;
}

.provider {
	position: relative;
	border-bottom: 0px solid $border-color !important;
	padding-top: 0;
	padding-bottom: 1rem;
	margin-bottom: 0;
	margin-top: 1rem;

	@include media-breakpoint-up(lg) {
		border-bottom: 0 solid $border-color !important;
	}

	&:first-child {
		&::before {
			display: block;
		}
	}

	&:last-child {
		&::before {
			content: '';
			display: none;
		}
	}
	@include media-breakpoint-down(md) {
		&:nth-child(odd) {
			&::before {
				content: '';
				display: none;
			}
		}

		&:last-child {
			border-bottom: 0 solid $border-color !important;

			&::before {
				content: '';
				display: block;
				position: absolute;
				bottom: 1rem;
				top: 0;
				right: 0;
				border-right: 0px solid $border-color !important;
			}
		}
	}

	&::before {
		content: '';
		display: block;
		position: absolute;
		bottom: 1rem;
		top: 0;
		right: 0;
		border-right: 0px solid $border-color !important;
	}

	.btn-provider {
		background-color: $theme-lightblue;
		&:hover, &.active {
			.btn_provider-svg.qr {
				filter: brightness(0) invert(1);
			}
		}
	}
}
</style>
